import React, { useState } from 'react'
import Header from './Header'
import Swiper from './Swiper1'
import Category from './Category';
import Client from './Client';
import { Link, useNavigate } from 'react-router-dom';
import Footer2 from './Footer2';
const Home = () => {
    const navigate = useNavigate();
    const onshop = () => {
        navigate('/');
    }
    const onProtfolio = () => {
        navigate('/bio');
    }
    const onContact = () => {
        navigate('/contact');
    }
    const handleClick = () => {
        navigate('/collaborationform');
    };
    return (
        <>
            {/* header part start  */}
            <Header />
            {/* header part end  */}

            {/* about part start  */}
            <div className="about-main">
                <div className="container">
                    <div className="about-inner-main">
                       
                        <div className="about-child">
                            <div className="about-inner-child">
                                <p className='about-one'>About VV Design Studio</p>
                                <p className='about-two'>Welcome to our creative corner, where imagination meets craftsmanship! We specialize in <span className='about-three'>Resin Art, Glass Paintings, Pyrography, and Alcohol Ink Art—</span> each piece thoughtfully handcrafted to bring beauty and uniqueness into your space. Our passion lies in transforming simple materials into stunning works of art that spark emotion and elevate everyday surroundings.</p>
                                
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* about part end  */}

            {/* bio part start  */}
            <div className="bio-main">
                <div className="container">
                    <p className='bio-one'>Artist Bio</p>
                    <div className="bio-inner-main">
                        <div className="bio-child">
                            <div className="bio-inner-child">
                                <img src="assets/img/artistbio2.jpg" alt="Artist" />
                            </div>
                        </div>
                        <div className="bio-child">
                            <div className="bio-inner-child">
                                <p className='bio-two'>
                                    Professionally an interior designer, Vibha is a passionate self-taught artist,
                                    specializing in multiple artforms including pyrography, glass painting, resin art,
                                    and alcohol ink art. Starting out with hobby, Vibha went beyond the standard
                                    drawing and painting and learned novel artforms to create masterpieces that
                                    signify a core moment in people's lives.
                                </p>

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* bio part end  */}
            {/* swiper part start  */}
            <Swiper />
            {/* swiper part end  */}
            <Footer2/>
       
            
            {/* category part start  */}

            {/* <Category /> */}

            {/* category part end */}
                    </>
    )
}

export default Home
